/* unplugin-vue-components disabled */import script from "./MidComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./MidComponents.vue?vue&type=script&setup=true&lang=js"

import "./MidComponents.vue?vue&type=style&index=0&id=55a3e910&lang=less"

const __exports__ = script;

export default __exports__